import { Suspense, useContext, useEffect } from "react"
import OrderDetailHOC from "hoc/OrderDetailHOC"
import SummaryProductList from "components/OrderDetail/SummaryProducts/SummaryProductsList"
import { OrderDetailType } from "types/OrderType"
import useDeliveryOrder from "pages/DetailOrderScreens/Delivery/UseDeliveryOrder"
import DeliveryAction from "components/OrderDetail/DeliveryProductOrder/DeliveryAction"
import SkeletonShippinGroupDetail from "components/Commons/Skeleton/SkeletonShippinGroupDetail"
import TagPrintContent from "components/OrderDetail/TagPrint/TagPrintContent"
import { AuthContext } from "context/context/AuthContext"
import { clients } from "webapp-clients/Clients"
import useHideActionButtons from "hooks/UseHideActionButtons"
import { IconCancel } from "theme/common/Icon.styled"
import { ButtonStyled } from "theme/common/Button.styled"
import ContentDetailOrderActionsStyled from "theme/common/ContentDetailOrderActions.styled"
import { EShippinggroupAction } from "enums/shippinggroupEmun"
import useCancelDecreaseOrder from "hooks/UseCancelDecreaseOrder"
import { WebAppClientsEnum } from "enums/CommonEnum"
import UseCancelOrder from "hooks/UseCancelOrder"
import { useGetCancelActionByClient } from "hooks/UseGetMultiClient"
import { useEnv } from "hooks"

const DeliveryScreen = ({
  shippinGroupDetail,
  shippingGroupId,
  finishedShippingGroupAction,
  order,
  setFinishedShippingGroupAction,
}: OrderDetailType) => {
  const {
    state: { user },
  } = useContext(AuthContext)
  const {hideDeliveryActions, updateVisibilityButtonActions} = useHideActionButtons()
  const [_client] = useEnv().multiclient.get_user_env()

  useEffect(() => {
    updateVisibilityButtonActions(
      shippinGroupDetail?.source?.id,
      shippinGroupDetail?.target?.source?.id
    )
  }, [shippinGroupDetail, updateVisibilityButtonActions])

  const client = clients[user?.mainGroup.id as keyof typeof clients]
  const FilesList = client["FilesList" as keyof typeof client]

  const FormFileShippingGroup = client["FormFileShippingGroup" as keyof typeof client]

  const itemsOrder = shippinGroupDetail?.source.items
  const documents = shippinGroupDetail?.custom?.documents
  const elockerInfo = shippinGroupDetail?.custom?.infoElocker

  const { loadingDelivey, handleClickDeliveryOrder } = useDeliveryOrder({
    shippingGroupId,
    setFinishedShippingGroupAction,
  })

  const {
    handleClickCancelDecreaseOrder,
    loadingCancelDecrase,
    canIuseCancelDecraese
  } = useCancelDecreaseOrder({
    order,
    shippingGroupId
  })

  const handleClickCancelDecrease = () => {
    handleClickCancelDecreaseOrder(EShippinggroupAction.cancel_decrease)
  }

  const [permissionOrder, actionOrder] = useGetCancelActionByClient()

  const handleClickCancel = () => {
    handleClickCancelOrder(actionOrder)
  }

  const {
    handleClickCancelOrder,
    loadingCancel,
    canIuseCancel
  } = UseCancelOrder({
    order,
    shippingGroupId,
    permissionOrder,
  })

  return (
    <>
      {itemsOrder ? (
        <>
          {canIuseCancel && _client === WebAppClientsEnum.sandbox && (
            <ContentDetailOrderActionsStyled style={user?.mainGroup.id === "privilege" ? { maxWidth: "400px", margin: "0 auto" } : {}}>
              <ButtonStyled
                variant="secondary"
                onClick={handleClickCancel}
                loadingButton={loadingCancel}
                disabled={loadingCancel}
              >
                <IconCancel />
                <span>Cancelar Orden</span>
              </ButtonStyled>
            </ContentDetailOrderActionsStyled>
          )}
          
          <SummaryProductList
            itemsOrder={itemsOrder}
            groupPicking={false}
            titleMain={finishedShippingGroupAction ? "Productos despachados" : undefined}
          />

          {canIuseCancelDecraese && (
            <ContentDetailOrderActionsStyled style={user?.mainGroup.id === "privilege" ? { maxWidth: "400px", margin: "0 auto" } : {}}>
              <ButtonStyled
                variant="secondary"
                onClick={handleClickCancelDecrease}
                loadingButton={loadingCancelDecrase}
                disabled={loadingCancelDecrase}
              >
                <IconCancel />
                <span>Cancelar Orden sin Modificar Inventario</span>
              </ButtonStyled>
            </ContentDetailOrderActionsStyled>
          )}

          {!finishedShippingGroupAction && !hideDeliveryActions && (
            <>
              {FormFileShippingGroup && (
                <Suspense fallback={null}>
                  <FormFileShippingGroup />
                </Suspense>
              )}
              <div style={user?.mainGroup.id === "privilege" ? { maxWidth: "400px", margin: "0 auto" } : {}}>
                <DeliveryAction
                  loadingDelivery={loadingDelivey}
                  onClickDeliveryOrder={handleClickDeliveryOrder}
                />
              </div>
            </>
          )}
          {order && (
            <TagPrintContent
              codigoEntrega={(elockerInfo?.isElocker && elockerInfo?.codigoEntrega) || null}
              order={order}
              shippingGroupId={shippingGroupId}
            />
          )}
          {FilesList && (
            <Suspense fallback={null}>
              <FilesList
                documents={documents}
                channel={shippinGroupDetail?.channel}
                orderId={order?.id}
                shippingGroupId={shippingGroupId}
              />
            </Suspense>
          )}
        </>
      ) : (
        <SkeletonShippinGroupDetail />
      )}
    </>
  )
}

export default OrderDetailHOC(DeliveryScreen)
